<template>
  <div>
    <b-loading v-if="loading" :is-full-page="true" :active="loading" />
    <edit-live-add-waypoint-form
      v-else-if="live && liveStage"
      :live="live"
      :live-stage="liveStage"
      :loading="loading"
      :stage-routes="stageRoutes"
      :stage-waypoints="stageWaypoints"
      :live-categories="liveCategories"
      @submit="submit"
    />
    <b-message v-else type="is-danger"> Une erreur interne est survenue. </b-message>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import EditLiveAddWaypointForm from './EditLiveAddWaypointForm'

export default {
  name: 'EditLiveAddWaypointTab',

  components: {
    EditLiveAddWaypointForm,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
    liveStageId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      stageRoutes: { public: [], private: [] },
      stageWaypoints: [],
      liveCategories: [],
      live: null,
      liveStage: null,
    }
  },

  async created() {
    this.loading = true

    await Promise.all([
      this.fetchLive(),
      this.fetchLiveStage(),
      this.fetchWaypoints(),
      this.fetchLiveCategories(),
      this.fetchStageByAccessType('public'),
      this.fetchStageByAccessType('private'),
    ])

    this.loading = false
  },

  methods: {
    ...mapActions('ui', ['addToastMessage']),

    async submit(waypoint) {
      this.loading = true

      try {
        const liveStageWaypoint = await this.$services.liveStageWaypointService.create({
          liveStageId: this.liveStageId,
          ...waypoint,
        })

        this.addToastMessage({
          text: `Le waypoint "${liveStageWaypoint.name}" a été créé.`,
          type: 'is-success',
        })

        await this.$router.push({ name: 'live.edit.stage.edit', params: { tab: 2 } })
      } catch (err) {
        this.addToastMessage({
          text: 'Une erreur interne est survenue.',
          type: 'is-danger',
        })
        console.error(err)
      }

      this.loading = false
    },

    async fetchLive() {
      try {
        this.live = await this.$services.liveService.getById(this.id)
      } catch (e) {
        console.error(e)
      }
    },

    async fetchLiveStage() {
      try {
        this.liveStage = await this.$services.liveStageService.getById(this.liveStageId)
      } catch (e) {
        console.error(e)
      }
    },

    async fetchWaypoints() {
      try {
        this.stageWaypoints = await this.$services.liveStageWaypointService.getAll(this.liveStageId)
      } catch (e) {
        this.stageWaypoints = []
      }
    },

    async fetchStageByAccessType(accessType) {
      try {
        this.stageRoutes[accessType] =
          await this.$services.liveStageRouteService.getAllByAccessType(
            this.liveStageId,
            accessType,
          )
      } catch (e) {
        this.stageRoutes[accessType] = []
      }
    },

    async fetchLiveCategories() {
      try {
        this.liveCategories = await this.$services.liveCategoryService.getAll(this.id)
      } catch (e) {
        this.liveCategories = []
      }
    },
  },
}
</script>
